import React, { useState } from "react";
import jwtDecode from "jwt-decode";
import AdminResetPasswordModal from "./resetPasswordModal";

export default function Header(props) {
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const [showResetPassword, setShowResetPassword] = useState(false);

  const logOut = () => {
    props.adminLogout();
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row m-auto align-items-center">
          <div className="col-4 d-flex align-items-center logo-link">
            <button
              className="sidebar-toggle-btn"
              onClick={() => props.setSidebarCollapsed(!props.sidebarCollapsed)}
              aria-label="Toggle Sidebar"
            >
              <i className={props.sidebarCollapsed ? "fa fa-indent" : "fa fa-outdent"} aria-hidden="true"></i>
            </button>
            <img
              src="/resources/logo/logo.png"
              className="mt0 header-logo-imageA"
              alt="logo"
            />
          </div>

          <div className="col-4 d-flex align-items-center justify-content-center">
            {/* Center spacer */}
          </div>
          
          {props.state.isAdminAuthenticated && (
            <div className="col-4 d-flex align-items-center justify-content-end">
              <div className="adminType">
                {adminType === 1
                  ? "Admin"
                  : adminType === 2
                  ? "Super Admin"
                  : adminType === 3
                  ? "Intermediate Admin"
                  : adminType === 23
                  ? "CFO"
                  : ""}
              </div>
              
              <button
                className="admin-action-btn"
                onClick={() => setShowResetPassword(true)}
              >
                <i className="fa fa-key" aria-hidden="true"></i>
                <span>Reset Password</span>
              </button>
              
              <button 
                className="admin-action-btn logout-btn" 
                onClick={(e) => logOut(e)}
              >
                <i className="fa fa-sign-out" aria-hidden="true"></i>
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>

      <AdminResetPasswordModal
        show={showResetPassword}
        onHide={() => setShowResetPassword(false)}
        token={props.state.payload}
      />
    </>
  );
}
